import { render, staticRenderFns } from "./UploadCoreCustomers.vue?vue&type=template&id=e8ed440c"
import script from "./UploadCoreCustomers.vue?vue&type=script&lang=js"
export * from "./UploadCoreCustomers.vue?vue&type=script&lang=js"
import style0 from "./UploadCoreCustomers.vue?vue&type=style&index=0&id=e8ed440c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports